(function () {
  let hasEmittedSubscriptionView = false;

  function emit(eventName, payload) {
    const data = payload || {};

    try {
      if (window.Shopify && window.Shopify.analytics && typeof window.Shopify.analytics.publish === 'function') {
        window.Shopify.analytics.publish(eventName, data);
      }
    } catch (error) {
      console.warn('Analytics publish failed', eventName, error);
    }

    if (Array.isArray(window.dataLayer)) {
      window.dataLayer.push({ event: eventName, ...data });
    }
  }

  function onceInView(selector, eventName, payloadFactory) {
    const element = document.querySelector(selector);
    if (!element || !('IntersectionObserver' in window)) return;

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          emit(eventName, typeof payloadFactory === 'function' ? payloadFactory(element) : {});
          observer.disconnect();
        });
      },
      { threshold: 0.35 }
    );

    observer.observe(element);
  }

  function setupTrackedClicks() {
    document.addEventListener('click', (event) => {
      const target = event.target.closest('[data-dmd-track]');
      if (!target) return;

      emit(target.dataset.dmdTrack, {
        label: target.dataset.dmdLabel || target.textContent.trim(),
        href: target.getAttribute('href') || '',
      });
    });
  }

  function setupFaqTracking() {
    document.addEventListener('toggle', (event) => {
      const details = event.target;
      if (!(details instanceof HTMLDetailsElement) || !details.open) return;

      const summary = details.querySelector('summary');
      emit('faq_open', {
        question: summary ? summary.textContent.trim() : details.id,
      });
    });
  }

  function setupReviewFilters() {
    document.querySelectorAll('[data-dmd-review-hub]').forEach((hub) => {
      const buttons = hub.querySelectorAll('[data-filter-value]');
      const cards = hub.querySelectorAll('[data-review-card]');

      buttons.forEach((button) => {
        button.addEventListener('click', () => {
          const value = button.dataset.filterValue;

          buttons.forEach((chip) => chip.classList.toggle('is-active', chip === button));

          cards.forEach((card) => {
            const useCase = card.dataset.useCase || '';
            card.hidden = value !== 'all' && useCase !== value;
          });

          emit('review_filter_use', { filter: value });
        });
      });
    });
  }

  function setupMediaTracking() {
    document.addEventListener('click', (event) => {
      const mediaTarget = event.target.closest('[data-media-id], [data-target]');
      if (!mediaTarget) return;

      emit('product_media_interaction', {
        target: mediaTarget.getAttribute('data-target') || mediaTarget.getAttribute('data-media-id') || '',
      });
    });
  }

  function syncStickyPurchaseOption() {
    const stickyBars = document.querySelectorAll('[data-dmd-sticky-atc]');
    if (!stickyBars.length) return;

    const radios = document.querySelectorAll(".shopify_subscriptions_app_container input[type='radio']");
    const selectedOption = document.querySelector(".shopify_subscriptions_app_container input[type='radio']:checked");

    if (radios.length && !hasEmittedSubscriptionView) {
      emit('subscription_option_view', { options: radios.length });
      hasEmittedSubscriptionView = true;
    }

    stickyBars.forEach((stickyBar) => {
      const purchaseWrap = stickyBar.querySelector('.sticky-atc-purchase');
      const purchaseLabel = stickyBar.querySelector('.sticky-atc-purchase__label');
      const purchasePrice = stickyBar.querySelector('.sticky-atc-purchase__price');

      if (!purchaseWrap || !purchaseLabel || !purchasePrice) return;

      if (!selectedOption) {
        purchaseWrap.hidden = true;
        return;
      }

      const optionText = selectedOption.closest('label')?.textContent?.replace(/\s+/g, ' ').trim() || '';
      const optionPrice = selectedOption.dataset.variantPrice || '';
      const isOneTime = selectedOption.dataset.radioType === 'one_time_purchase';

      purchaseLabel.textContent = isOneTime ? 'One-time purchase selected' : optionText;
      purchasePrice.textContent = optionPrice;
      purchaseWrap.hidden = false;
    });
  }

  function setupSubscriptionTracking() {
    syncStickyPurchaseOption();

    document.addEventListener('change', (event) => {
      const radio = event.target.closest(".shopify_subscriptions_app_container input[type='radio']");
      if (!radio || !radio.checked) return;

      syncStickyPurchaseOption();
      emit('subscription_option_select', {
        option: radio.dataset.radioType || 'selling_plan',
        price: radio.dataset.variantPrice || '',
        selling_plan_id: radio.dataset.sellingPlanId || '',
      });
    });
  }

  function setupDynamicSync() {
    let queued = false;

    const queueSync = () => {
      if (queued) return;
      queued = true;

      window.requestAnimationFrame(() => {
        queued = false;
        syncStickyPurchaseOption();
      });
    };

    const isRelevantNode = (node) => {
      if (!(node instanceof Element)) return false;
      if (node.matches('.sticky-atc, .shopify_subscriptions_app_container')) return true;

      return !!node.querySelector('.sticky-atc, .shopify_subscriptions_app_container');
    };

    const observer = new MutationObserver((mutations) => {
      const shouldSync = mutations.some((mutation) => {
        if (isRelevantNode(mutation.target)) return true;

        return Array.from(mutation.addedNodes).some(isRelevantNode);
      });

      if (shouldSync) queueSync();
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true,
    });

    document.addEventListener('product-info:loaded', queueSync);
  }

  function setupCollectionComparisonTracking() {
    document.querySelectorAll('[data-dmd-comparison]').forEach((section) => {
      section.querySelectorAll('a, button').forEach((control) => {
        control.addEventListener('click', () => {
          emit('collection_comparison_interaction', {
            label: control.dataset.dmdLabel || control.textContent.trim(),
          });
        });
      });
    });
  }

  function setupProductFormTracking() {
    document.querySelectorAll("form[data-type='add-to-cart-form']").forEach((form) => {
      form.addEventListener('submit', () => {
        emit('add_to_cart', {
          product_id: form.querySelector("input[name='id']")?.value || '',
        });
      });
    });
  }

  document.addEventListener('DOMContentLoaded', () => {
    setupTrackedClicks();
    setupFaqTracking();
    setupReviewFilters();
    setupMediaTracking();
    setupSubscriptionTracking();
    setupDynamicSync();
    setupCollectionComparisonTracking();
    setupProductFormTracking();

    onceInView('[data-dmd-planner-finder]', 'planner_finder_start', () => ({ source: 'section_view' }));
  });
})();
